import Svg, { Path, type SvgProps } from 'react-native-svg'

export function HideIcon(props: SvgProps) {
  return (
    <Svg width={24} height={25} viewBox="0 0 24 25" fill="none" {...props}>
      <Path
        d="M10.7334 5.81208C13.0628 5.53448 15.419 6.02689 17.4423 7.21412C19.4655 8.40135 21.0446 10.2182 21.9384 12.3871C22.0217 12.6116 22.0217 12.8586 21.9384 13.0831C21.5709 13.9741 21.0852 14.8116 20.4944 15.5731"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.0846 14.8941C13.5188 15.4406 12.761 15.743 11.9744 15.7361C11.1878 15.7293 10.4354 15.4138 9.87917 14.8576C9.32294 14.3013 9.00744 13.5489 9.0006 12.7623C8.99377 11.9757 9.29615 11.2179 9.84262 10.6521"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.4795 18.2351C16.153 19.0209 14.673 19.5121 13.1399 19.6755C11.6068 19.8389 10.0565 19.6706 8.59414 19.182C7.13182 18.6934 5.7917 17.896 4.66472 16.8439C3.53773 15.7917 2.65026 14.5095 2.06251 13.0841C1.97916 12.8596 1.97916 12.6126 2.06251 12.3881C2.94914 10.238 4.50918 8.43336 6.50851 7.24512"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.00049 2.73608L22.0005 22.7361"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
